import React from "react";

interface LoadingBarProps {
  progress: number;
  message?: string;
  notification?: boolean;
  failed?: boolean;
}

const LoadingBar: React.FC<LoadingBarProps> = ({
  progress,
  message,
  notification,
  failed = false,
}) => {
  return (
    <>
      {!failed ? (
        <div className={`w-full`}>
          <p
            className={`text-xs 2xl:text-sm text-gray-600 mb-1 min-h-[1rem] 2xl:min-h-[1.25rem] ${
              notification && "line-clamp-1 "
            }`}
          >
            {message}
            <span
              className="loading-dots w-[10px] ml-0.5"
              aria-hidden="true"
            ></span>
          </p>

          <div className="flex space-x-3 items-center">
            <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden mb-1">
              <div
                role="progressbar"
                aria-valuenow={Math.floor(progress)}
                aria-valuemin={1}
                aria-valuemax={100}
                className="h-full bg-blue-600 transition-all duration-100"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="text-sm text-gray-600">{Math.floor(progress)}%</p>
          </div>
        </div>
      ) : (
        <div className={`w-full`}>
          <p
            className={`text-xs 2xl:text-sm text-gray-600 mb-1 mt-5 ${
              notification && "line-clamp-1 "
            }`}
          >
            Report generation failed ❌
          </p>
        </div>
      )}
    </>
  );
};

export default LoadingBar;
